module.exports = __webpack_public_path__ + "img/b1.a786a6e1.png";